import React, { useMemo } from "react";
import _ from "lodash/fp";
import { GridGenerator } from "@actinc/dls/components";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";

import { ControlledFormInput, DraggableDialog } from "../../../components";

const SRAccessibilityDialog = ({
  handleClose,
  open,
  option: { elements = [], label, range },
  readonly,
  tag = {},
}) => {
  const { control, getValues } = useForm({
    mode: "all",
    defaultValues: { ...tag },
  });

  const action = useMemo(
    () => (tag.identifier ? "edit" : "create"),
    [!!tag.identifier],
  );

  return (
    <DraggableDialog
      maxWidth="md"
      open={open}
      title={`${_.capitalize(action)} SR Accessibility`}
    >
      <DialogContent>
        {tag.content && label !== "Image" && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 2,
            }}
          >
            <Typography variant="h6">Selected Content</Typography>
            <Box
              dangerouslySetInnerHTML={{
                __html: !!tag?.selectedContent
                  ? tag.selectedContent
                  : tag?.content,
              }}
            />
          </Box>
        )}
        <form id="sr-dialog-form">
          <GridGenerator
            groups={[
              [
                {
                  children: (
                    <ControlledFormInput
                      control={control}
                      disabled={readonly}
                      fullWidth={true}
                      id="sr-accessible-text"
                      label="Accessible Text"
                      multiline={true}
                      name="content"
                    />
                  ),
                  key: "sr-accessible-text",
                },
              ],
            ]}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()()} variant="text">
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={readonly}
          onClick={() => handleClose({ elements, label, range })(getValues())}
          variant="contained"
        >
          {"Okay"}
        </Button>
      </DialogActions>
    </DraggableDialog>
  );
};

export { SRAccessibilityDialog };
